export default __webpack_public_path__ + "static/media/sass.67308595.svg";